<mat-table #table matSort [matSortDisableClear]="true" [dataSource]="dataSource">
  <ng-container matColumnDef="ExternalId">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Turnr.</mat-header-cell>
    <mat-cell *matCellDef="let order">{{order.ExternalId}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Carrier">
    <mat-header-cell *matHeaderCellDef>Bærer</mat-header-cell>
    <mat-cell *matCellDef="let order">{{order.CarrierName}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Username">
    <mat-header-cell *matHeaderCellDef>Bruker</mat-header-cell>
    <mat-cell *matCellDef="let order">{{order.Username}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Status">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Status</mat-header-cell>
    <mat-cell *matCellDef="let order">{{order.Status | orderStatusName}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="CreatedAt">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Opprettet</mat-header-cell>
    <mat-cell *matCellDef="let order">{{order.CreatedAt | date:'dd.MM HH:mm'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="UpdatedAt">
    <mat-header-cell mat-sort-header *matHeaderCellDef>Oppdatert</mat-header-cell>
    <mat-cell *matCellDef="let order">{{order.UpdatedAt | date:'dd.MM HH:mm'}}</mat-cell>
  </ng-container>

  <ng-container matColumnDef="Assign">
    <mat-header-cell *matHeaderCellDef>Tildeling</mat-header-cell>
    <mat-cell *matCellDef="let order">
      <button mat-stroked-button color="primary" *ngIf="order.Username == null"
              (click)="assign(order, $event)">Tildel
      </button>
      <button mat-stroked-button color="warn" *ngIf="order.Username != null"
              (click)="unassign(order, $event)">Fjern tildeling
      </button>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

  <mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectOrder(row)" [class.selected]="selectedOrders.isSelected(row)"></mat-row>
</mat-table>
